import axios from "axios";

class CartApi {
    constructor() {
    }

    getCart() {
        return axios.get('/api/v1/cart');
    }

    clearCart() {
        return axios.post('/api/v1/cart/clear');
    }

    addToCart(data) {
        return axios.post(`/api/v1/cart/add`, data);
    }
}

export default new CartApi();
